// src/config/app.config.ts

export const AppConfig = {
  api: {
    baseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080',
    version: process.env.REACT_APP_API_VERSION || 'v1',
    get base() {
      return `${this.baseUrl}/api/${this.version}`;
    },
    get loginEndpoint() {
      return `${this.base}/auth/login`;
    },
    get packagesEndpoint() {
      return `${this.base}/packages`;
    },
  },
  app: {
    name: process.env.REACT_APP_APP_NAME || 'LogiTrack',
    jwtStorageKey: process.env.REACT_APP_JWT_STORAGE_KEY || 'logitrack_token',
  },
} as const;
